import { Component, OnInit } from '@angular/core';

import { LayoutService } from '../../shared/services/layout.service';

@Component({
    selector: 'login-registration-success',
    templateUrl: 'registration-success.component.html'
})

export class LoginRegistrationSuccessComponent{
    
    constructor(
        private _layoutService: LayoutService
    ) {
        
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('login-registration-success');
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/login/components/registration-success.component.ts